import { colors } from '../../colors';
var input = {
  textColor: colors.ash
};
export default input;